import axios from 'axios'

export default {
    checkResponse(response) {
        if (response) {
            if (!!response.data.deactivated) {
                if (window.location.pathname != '/login') {
                    return window.location.href = '/login';
                }
            } else {
                return response.data
            }
        } else {
            toastr['error']('Ошибка', 'Ошибка');

            return window.location.href = '/login';
        }
    },
    getMainSetting() {

        return axios.get('/settings/main')
            .then(response => {

                return this.checkResponse(response);
            })
    },
    updateSettings(setting) {

        return axios.post('/settings/' + setting.id, {
            edit_date: setting.edit_date
        })
            .then(response => {

                return this.checkResponse(response)
            })
    }
}



// WEBPACK FOOTER //
// ./resources/js/services/settingsDataService.js